export default (state) => val => {
    return state.list.filter(i => {
        return i.code === val;
    })[0];
}